var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[(_vm.canUserAccessRemoteLog)?[_c('monitor-view')]:[_c('user-view')]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }